import { render, staticRenderFns } from "./FormAddRegistration.vue?vue&type=template&id=d825bb80&scoped=true"
import script from "./FormAddRegistration.vue?vue&type=script&lang=js"
export * from "./FormAddRegistration.vue?vue&type=script&lang=js"
import style0 from "./FormAddRegistration.vue?vue&type=style&index=0&id=d825bb80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d825bb80",
  null
  
)

export default component.exports